export default "__VITE_ASSET__BqXqYqwg__"